Array.prototype.removeByKey = function (key, value) {
  this.some((function (item, index) {
    return (this[index][key] === value) ? !!(this.splice(index, 1)) : false;
  }).bind(this));
  return this;
}

jQuery.extend({
    LazyLoadAttachedEvents: [],
    LazyLoad: function (options) {

        var defaultOptions = {
            Offset: 0,
            AppendScroll: window,
            ElementVisibleId: "",
            UpdateAction: function (isVisible) { },
            Name: ""
        }

        var defaultOptiosTemp = {};
        jQuery.extend(true, defaultOptiosTemp, defaultOptions);
        var configuration = jQuery.extend(true, defaultOptiosTemp, options);


        var callbackAction = function () {
            var EventHandlerName = configuration.UpdateAction(visibleY());

            if (EventHandlerName) {
                jQuery.LazyLoadAttachedEvents.removeByKey(EventHandlerName)
            }

        };

        var visibleY = function () {
            el = document.getElementById(configuration.ElementVisibleId);
            if (!el || el.offsetHeight === 0) {
                return false;
            }

            var top = el.getBoundingClientRect().top, rect, el = el.parentNode;

            while (el != document.body) {
                rect = el.getBoundingClientRect();
                if (top <= rect.bottom === false)
                    return false;
                el = el.parentNode;
            };

            // Check its within the document viewport
            var isVisible = top - configuration.Offset <= document.documentElement.clientHeight;
            return isVisible;

        };

        if (configuration.Name === "") {
            jQuery(configuration.AppendScroll).on("scroll", callbackAction);
        }
        else if (configuration.Name !== "" && jQuery.LazyLoadAttachedEvents.indexOf(configuration.Name) < 0 ){
            jQuery.LazyLoadAttachedEvents.push(configuration.Name);
            jQuery(configuration.AppendScroll).on("scroll", callbackAction);
        }
        
        jQuery(window).on("resize", callbackAction);

        callbackAction();
    }
});
